<template>
    <div v-if="visible" class="email-popup-overlay" @click.self="closePopup">
        <div class="email-popup-modal">
            <div class="popup-image-col">
                <img :src="imageSrc" alt="Join Mailing List" />
            </div>
            <button class="close-btn" @click="closePopup">[Close]</button>
            <div class="popup-content-col">
                <div class="content-wrapper">
                    <p style="font-size: 16rem;padding-bottom: 20rem;">Worth Staying For.</p>
                    <p class="subtitle">New collections, studio stories, and the occasional surprise…</p>

                    <form @submit.prevent="submitEmail" class="email-form">
                        <div class="input-group">
                            <input
                                type="email"
                                id="email"
                                v-model="email"
                                class="email-input"
                                placeholder="Your Email Address"
                                :disabled="submitting"
                                required
                            />
                        </div>

                        <div class="submit-wrapper">
                            <button type="submit" class="submit-btn" :disabled="submitting">
                                {{ submitting ? 'Submitting...' : '[Submit]' }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import founderImg from '@/assets/mobile/email_bg.png'
import { subscribeEmail } from '@/api/content'
import { showMessage } from '@/config/message'

export default {
    name: 'MobileEmailPopup',
    props: {
        // 改用 visible 支持 .sync
        visible: {
            type: Boolean,
            default: false
        },
        // 用于兼容原来的 open prop（如果父组件仍使用 open）
        open: {
            type: Boolean,
            default: false
        },
        // 是否启用自动弹出（由父组件决定）
        autoShowDelay: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            email: '',
            imageSrc: founderImg,
            submitting: false,
            autoTimer: null
        }
    },
    computed: {
        isVisible() {
            // 优先使用 visible，兼容 open
            return this.visible !== undefined ? this.visible : this.open;
        }
    },
    watch: {
        isVisible(val) {
            if (!val) {
                this.$emit('close');
                this.$emit('update:visible', false);
                // 兼容旧版 open 事件
                this.$emit('update:open', false);
            }
        }
    },
    mounted() {
        // 不再自动弹出，完全由父组件控制
        // 移除定时器，移除全局事件监听（如果需要保留可以保留，但建议父组件触发）
        // 为了兼容性，可以保留事件监听但不再做自动弹窗
        window.addEventListener('open-email-popup', this.openPopupByEvent);
    },
    beforeDestroy() {
        if (this.autoTimer) clearTimeout(this.autoTimer);
        window.removeEventListener('open-email-popup', this.openPopupByEvent);
    },
    methods: {
        openPopupByEvent() {
            // 由全局事件触发时，也检查条件？可以由外部组件在触发前判断
            this.$emit('update:visible', true);
        },
        closePopup() {
            // 关闭时记录标记已在父组件中处理（localStorage），这里只负责关闭
            this.$emit('update:visible', false);
        },
        async submitEmail() {
            if (this.submitting) return;

            if (!this.email || this.email.trim() === '') {
                showMessage('Please fill out this field.', 'error');
                return;
            }

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(this.email)) {
                showMessage('Please enter a valid email address.', 'error');
                return;
            }

            this.submitting = true;

            try {
                const response = await subscribeEmail(this.email);
                if (response && response.retCode === 1) {
                    showMessage('Thank you for joining our mailing list!', 'success');
                    this.closePopup();
                    this.email = '';
                } else {
                    showMessage(response.retMsg || 'Subscription failed', 'error');
                    this.closePopup();
                }
            } catch (error) {
                console.error('Subscription error:', error);
                showMessage('An error occurred. Please try again.', 'error');
            } finally {
                this.submitting = false;
            }
        }
    }
}
</script>

<style scoped>
/* 样式与用户提供的一致，无需修改 */
.close-btn {
    position: absolute;
    top: 11rem;
    left: 50%;
    transform: translateX(-50%);
    background: none;
    border: none;
    font-size: 13rem;
    cursor: pointer;
    line-height: 1;
    color: #000;
    padding: 5rem;
    font-weight: 500;
    font-family: 'Apercu', sans-serif !important;
}
.email-popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 20001;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20rem;
}

.email-popup-modal {
    background-color: #fff;
    width: 100%;
    max-width: 305rem;
    display: flex;
    flex-direction: column;
    box-shadow: 0 10rem 40rem rgba(0,0,0,0.2);
    overflow: hidden;
    border: 2px solid #000000;
    position: relative;
}

.popup-image-col {
    width: 100%;
    height: 250rem;
    background-color: #f5f5f5;
    position: relative;
}

.popup-image-col img {
    width: 100%;
    height: 247rem;
    object-fit: cover;
    display: block;
}

.popup-content-col {
    width: 100%;
    padding: 40rem 30rem;
    background: #fff;
}


.content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    font-family: 'Apercu', sans-serif !important;
}

h2 {
    font-size: 24rem;
    font-weight: 600;
    margin-bottom: 15rem;
    color: #000;
    text-align: center;
}

.subtitle {
    font-size: 13rem;
    color: #888;
    margin-bottom: 60rem;
    text-align: center;
    font-weight: 400;
    max-width: 240rem;
}

.email-form {
    width: 100%;
}

.input-group {
    margin-bottom: 10rem;
    width: 100%;
}

.email-input {
    width: 100%;
    border: none;
    border-bottom: 1rem solid #000;
    padding: 10rem 0;
    font-size: 13rem;
    outline: none;
    font-family: 'Apercu', sans-serif !important;
    background: transparent;
    color: #000;
    border-radius: 0;
}

.email-input::placeholder {
    color: #000;
    font-family: 'Apercu', sans-serif !important;
    opacity: 1;
}

.submit-wrapper {
    text-align: center;
}

.submit-btn {
    background: none;
    border: none;
    font-size: 13rem;
    font-weight: 600;
    cursor: pointer;
    color: #000;
    padding: 10rem 20rem;
    font-family: 'Apercu', sans-serif !important;
}
</style>